import { useState } from 'react'

import clsx from 'clsx'

import { Footer } from '@ui/layout/Footer'
import { Header } from '@ui/layout/Header'
import type { NavLink } from '@ui/layout/Header'
import { SignUpHrefContext } from '@ui/layout/signUpHref'
import { signUpUrl } from '@ui/lib/urls'

type Canvas = 'white' | 'light-blue'

const CANVAS: Record<Canvas, string> = {
  white: 'bg-white',
  'light-blue': 'bg-[#e6f7ff]',
}

export interface MarketingLayoutProps {
  bg?: Canvas
  chin?: Canvas
  banner?: boolean
  navLinks?: NavLink[]
  showBackButton?: boolean
  // Where every Get Started under this layout points. The app origin passes its own form.
  signUpHref?: string
  mainClassName?: string
  children: React.ReactNode
}

// Pages mount this through getLayout, so a dismissed banner survives navigation.
export function MarketingLayout({
  bg = 'white',
  chin,
  banner = true,
  navLinks,
  showBackButton,
  signUpHref = signUpUrl(),
  mainClassName,
  children,
}: MarketingLayoutProps) {
  const [showBanner, setShowBanner] = useState(true)

  return (
    <SignUpHrefContext.Provider value={signUpHref}>
      <div className="flex min-h-screen flex-col">
        <div className={clsx('fixed inset-0 -z-10', CANVAS[bg])} />
        <Header
          showBanner={banner && showBanner}
          onCloseBanner={() => setShowBanner(false)}
          navLinks={navLinks}
          showBackButton={showBackButton}
        />
        <main className={clsx('flex-grow', CANVAS[bg], mainClassName)}>
          {children}
        </main>
        <Footer chinColor={chin} />
      </div>
    </SignUpHrefContext.Provider>
  )
}
